// src/components/Homepage.js
import React from "react";
import { Link } from "react-router-dom";
import Gallery from "./Gallery";
import Testimonials from "./Testimonials";
import ServicesCards from "./ServicesCards";
import FederationLogos from "./FederationLogos";
import About from "./About";
import Contact from "./Contact";
import "./Homepage.css";

// The brand-story scroll: hook (hero, in App) -> offering -> coach -> proof ->
// act. Section ids (#services / #about / #contact) are the navbar anchor targets.
const Homepage = () => (
  <div className="homepage">
    <section className="home-section" id="services">
      <div className="section-heading">
        <p className="section-heading__eyebrow">The system</p>
        <h2>How coaching works</h2>
        <p>
          From your first message to meet day: what working together looks like.
        </p>
      </div>
      <ServicesCards />
    </section>

    <About />

    <section className="home-section">
      <div className="section-heading">
        <p className="section-heading__eyebrow">From the platform</p>
        <h2>Recent highlights</h2>
        <p>A look at the athletes and the meets. See the full collection below.</p>
      </div>
      <Gallery />
      <div className="home-cta">
        <Link to="/full-gallery" className="btn-primary">
          View full gallery
        </Link>
      </div>
    </section>

    <section className="home-section">
      <div className="section-heading">
        <p className="section-heading__eyebrow">In their words</p>
        <h2>What our athletes say</h2>
      </div>
      <Testimonials />
    </section>

    <FederationLogos />

    <Contact />
  </div>
);

export default Homepage;
